import React, {useContext} from 'react'
import  {FormControl, InputGroup} from "react-bootstrap"
import {Link} from "react-router-dom";
import {StateContext} from "../../context/GlobalState.jsx";
import {GetText} from "../../context/text.js";


function Search() {

    const {setSearchRequest, searchRequest, setSearchURL} = useContext(StateContext)

    let text = GetText();



    // render JSX
    return (
        <InputGroup className="mb-3">
            <FormControl
                onChange={(e) => setSearchRequest(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        setSearchURL(searchRequest); // Выполнить функцию
                        document.querySelector('#basic-addon1 > a').click(); // Симулировать клик на ссылке
                    }
                }}
                placeholder={text.Search.searchPlaceholder}
                aria-label={text.Search.searchPlaceholder}
                aria-describedby="basic-addon1"
            />
            <InputGroup.Text id="basic-addon1">
                <Link
                    title={text.Search.searchButton}
                    to={`/search-${searchRequest}`}
                    onClick={() => {
                        setSearchURL(searchRequest);
                    }}
                >
                    <i className="ri-search-line"></i> {text.Search.searchButton}
                </Link>
            </InputGroup.Text>
        </InputGroup>
    )
}

export default Search
